module.exports = __webpack_public_path__ + "img/54a82ad.png";